import {Directive, forwardRef, Attribute} from '@angular/core';
import {NG_VALIDATORS, AbstractControl, Validator, NgForm} from '@angular/forms';
import {Subscription} from 'rxjs';
import {isEmpty, isUndefined} from 'lodash';

const PROVIDER_VALIDATOR = {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => MatchValidator),
    multi: true
};

/**
 * Directive, which adds validators
 */
@Directive({
    selector: '[match]',
    providers: [PROVIDER_VALIDATOR]
})
export class MatchValidator implements Validator {

    private readonly validator: Function;

    constructor(private form: NgForm,
        @Attribute('match') public matchControlAlias: string) {
        this.validator = matchValidatorFactory(this.matchControlAlias);
    }

    validate(control: AbstractControl) {
        return this.validator(control);
    }

}

export function matchValidatorFactory(matchControlName) {
    let matchControlSubscr: Subscription;
    return (control: AbstractControl): {[key: string]: any} => {
        const matchControl = control.root.get(matchControlName);
        //
        if (isUndefined(matchControlSubscr) && matchControl) {
            matchControlSubscr = matchControl.valueChanges.subscribe((val) => {
                control.updateValueAndValidity();
            });
            if (!isEmpty(control.value)) {
                control.markAsTouched();
            }
        }
        //
        return (matchControl && control.value === matchControl.value) ? null : {match: {valid: false}};
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/matcher.directive.ts